module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery4_en.342de266ce3abb6c99e837ffd29fecf1.png";